<div class="std-margin flex space-between">
  <span class="pointer uppercase bold" (click)="selectMode()"><i class="fa hlf-margin-right" [ngClass]="{'fa-boxes': mode == 'quantity', 'fa-coins': mode == 'worth'}"></i>{{(mode=='quantity' ? 'Xem theo số lượng' : 'Xem theo giá trị') | lang}}</span>
  <date-picker [force]="true" [handler]="handler"></date-picker>
</div>

<panel *ngIf="range && (!loading || !goods.empty)">
  <text-filter [target]="goods" [placeholder]="'Tìm mã hàng'" right></text-filter>

  <ng-container header *ngFor="let i of paths; index as ix">
    <span *ngIf="ix > 0" class="hlf-margin-left hlf-margin-right">|</span>
    <span *ngIf="ix != 2" [ngClass]="{'pointer text-primary': i.children.length > 0 && i != report}" (click)="open(i)">{{i.name + (ix == 1 ? ' (' + partner(i.name) + ')': '')}}</span>
    <good *ngIf="ix == 2" [sku]="i.name"></good>
  </ng-container>

  <table responsive class="data hover" *ngIf="mode == 'worth'">
    <tr>
      <th priority="7" class="text-top text-right" style="width: 0">STT</th>
      <th priority="1" class="text-top text-left"><sortable [target]="goods" [extractor]="extractor('last-of-path')">{{primaryLabel}}</sortable></th>
      <th priority="3" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('initial')">{{'Tồn đầu' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('import')">{{'Nhập' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('import')">{{'Khách trả' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('return')">{{'Khách trừ' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('lost')">{{'Xuất mất' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('export')">{{'Xuất bán' | lang}}</sortable></th>
      <th priority="2" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('left')">{{'Tồn cuối' | lang}}</sortable></th>
      <th priority="6" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('exchange')">{{'Tỷ giá' | lang}}</sortable></th>
      <th priority="5" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('gross')">{{'Lãi gộp' | lang}}</sortable></th>
      <th priority="5" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('%')">{{'Lãi xuất' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of goods.pageMatches; index as ix">
      <td><small>{{ix + 1 + goods.pageIndex * goods.pageSize}}</small></td>
      <td>
        <div class="spacy bold" [ngClass]="{'pointer text-primary': i.children.length > 0, 'text-warning': i.children.length < 1}" (click)="open(i)">
          <span *ngIf="paths.length != 2">{{i.Path.last()}}</span>
          <good *ngIf="paths.length == 2" [sku]="i.Path.last()"></good>
        </div>
        <small *ngIf="paths.length < 2">{{partner(i.Path.last())}}</small>
        <small *ngIf="paths.length == 2">{{i.children.length}}<unit>màu</unit></small>
      </td>

      <td class="nowrap">

        <ng-container *ngIf="i.Initial.QuoteValue == i.Initial.QuoteWorth">
          <number class="bold" [good]="'none'" [sign]="false" [value]="i.base('initial', 'CNY')"></number>
          <cny></cny>
        </ng-container>

        <ng-container *ngIf="i.Initial.QuoteValue != i.Initial.QuoteWorth">
          <number class="bold" [good]="'none'" [sign]="false" [value]="i.Initial.QuoteValue" [decimal]="0"></number><vnd></vnd>
          <div class="small">
            <number [good]="'none'" [sign]="false" [value]="i.Initial.QuoteWorth" [decimal]="1"></number><cny></cny>
          </div>
        </ng-container>

      </td>

      <td class="nowrap">

        <number class="bold" [sign]="false" [good]="'negative'" [value]="i.base('import', 'CNY') - i.base('provider', 'CNY')"></number>
        <cny></cny>

        <br />

        <small *ngIf="i.base('provider', 'CNY') != 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="i.base('import','CNY')"></number>
          <b> - </b>
          <number [sign]="false" [good]="'none'" [value]="i.base('provider','CNY')"></number>
          <cny></cny>
        </small>

      </td>

      <td class="nowrap">

        <number class="bold" [sign]="false" [good]="'negative'" [value]="i.quote('return', 'VND')"></number><vnd></vnd>
        <br />
        <small *ngIf="i.quote('return','VND') > 0" class="pointer" (click)="openStatistics(i, 'returns')">

          <number [sign]="false" [decimal]="0" [value]="i.gross('return','CNY')"></number>
          <b> + </b>
          <number class="bold" [sign]="false" [good]="'none'" [value]="i.base('return','CNY')" [decimal]="1"></number>
          <cny></cny> <i class="fa fa-info-circle text-primary hlf-margin-left"></i>

        </small>

      </td>

      <td class="nowrap">
        <number class="bold" [good]="'negative'" [sign]="false" [value]="i.quote('discount', 'VND')" [decimal]="0"></number>
        <vnd></vnd>

        <br />

        <small *ngIf="total('Discount', i.Exports, i.Imports) > 0">
          <number [sign]="false" [value]="i.gross('discount', 'CNY')" [decimal]="0"></number>
          <b> + </b>
          <number class="bold" [sign]="false" [good]="'none'" [value]="i.base('discount', 'CNY')" [decimal]="1"></number>
          <cny></cny>
        </small>

      </td>

      <td class="nowrap">
        <number class="bold" [good]="'negative'" [sign]="false" [value]="i.base('lost','VND')" [decimal]="0"></number>
        <vnd></vnd>

        <br />

        <small *ngIf="total('Count', i.CompanyLosses) > 0">
          <number class="bold" [good]="'negative'" [sign]="false" [value]="i.base('lost', 'CNY')" [decimal]="1"></number>
          <cny></cny>
        </small>
      </td>

      <td class="nowrap">
        <number class="bold" [sign]="false" [value]="i.quote('export','VND')"></number>
        <vnd></vnd>

        <br />

        <small *ngIf="total('Count', i.Exports) > 0" class="pointer" (click)="openStatistics(i, 'exports')">
          <number [sign]="false" [decimal]="0" [value]="i.gross('export','CNY')"></number>
          <b> + </b>
          <number class="bold" [sign]="false" [good]="'none'" [value]="i.base('export','CNY')" [decimal]="1"></number>
          <cny></cny> <i class="fa fa-info-circle text-primary hlf-margin-left"></i>
        </small>
      </td>

      <td class="nowrap">

        <ng-container *ngIf="total('Count', i.Returns) == 0">
          <number class="bold" [good]="'positive'" [value]="i.base('left', 'CNY')" [decimal]="1"></number><cny></cny>
        </ng-container>

        <ng-container *ngIf="total('Count', i.Returns) > 0">
          <number class="bold" [good]="'positive'" [value]="i.base('left', 'VND')" [decimal]="0"></number><vnd></vnd>
          <br />
          <small>
            <number [good]="'none'" [value]="i.base('left', 'CNY')" [decimal]="1"></number><cny></cny>
          </small>
        </ng-container>

      </td>
      <td class="nowrap">
        <ng-container *ngIf="i.exchange != 0">
          <number [good]="'none'" [sign]="false" [value]="i.exchange" [decimal]="0"></number>
          <vnd-per-cny></vnd-per-cny>
        </ng-container>
      </td>
      <td class="nowrap">
        <number class="bold" [value]="i.gross('total','VND')" [decimal]="0"></number>
        <vnd></vnd>

        <br />

        <small *ngIf="i.gross('total','CNY') != 0">
          <number [good]="'positive'" [value]="i.gross('total', 'CNY')" [decimal]="0"></number>
          <cny></cny>
        </small>
      </td>
      <td class="nowrap">
        <number [good]="'positive'" [value]="i.base('profitable', 'CNY') != 0 ? i.gross('total', 'CNY') * 100 / i.base('profitable', 'CNY') : 0" [decimal]="1"></number>
        <unit>%</unit>
      </td>
    </tr>
    <tr *ngIf="goods.pages.length > 1">
      <td class="hidden"></td>
      <td [colSpan]="12" class="text-center" style="z-index: unset"><pagination [target]="goods"></pagination></td>
    </tr>

    <tr class="footer" *ngIf="goods.matches.length > 1">
      <td></td>
      <td class="bold">{{'TỔNG' | lang}} ({{goods.matches.length}})</td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('initial')" [decimal]="0"></number>
        <cny></cny>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('import')" [decimal]="0"></number>
        <cny></cny>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('return')" [decimal]="0"></number>
        <vnd></vnd>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('discount')" [decimal]="0"></number>
        <vnd></vnd>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('lost')" [decimal]="0"></number>
        <vnd></vnd>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('export')" [decimal]="0"></number>
        <vnd></vnd>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('left')" [decimal]="0"></number>
        <cny></cny>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('exchange')" [decimal]="0"></number><vnd-per-cny></vnd-per-cny>
      </td>
      <td>
        <number class="bold" [value]="statistics('gross-value')" [decimal]="0"></number>
        <vnd></vnd>
      </td>
      <td>
        <number class="bold" [value]="statistics('gross-percentage') * 100" [decimal]="1"></number>
        <unit>%</unit>
      </td>
    </tr>
  </table>

  <table responsive class="data hover" *ngIf="mode == 'quantity'">
    <tr>
      <th priority="5" class="text-top text-right" style="width: 0">STT</th>
      <th priority="1" class="text-top text-left"><sortable [target]="goods" [extractor]="extractor('last-of-path')">{{primaryLabel}}</sortable></th>
      <th priority="3" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('initial-quantity')">{{'Tồn đầu' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('import-quantity')">{{'Nhập' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('return-quantity')">{{'Khách trả' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('discount-quantity')">{{'Khách trừ' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('lost-quantity')">{{'Xuất mất' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('export-quantity')">{{'Xuất bán' | lang}}</sortable></th>
      <th priority="2" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('left-quantity')">{{'Tồn cuối' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of goods.pageMatches; index as ix">
      <td><small>{{ix + 1 + goods.pageIndex * goods.pageSize}}</small></td>
      <td>
        <div class="spacy bold" [ngClass]="{'pointer text-primary': i.children.length > 0, 'text-warning': i.children.length < 1}" (click)="open(i)">
          <span *ngIf="paths.length != 2">{{i.Path.last()}}</span>
          <good *ngIf="paths.length == 2" [sku]="i.Path.last()"></good>
        </div>
        <small *ngIf="paths.length < 2">{{partner(i.Path.last())}}</small>
        <small *ngIf="paths.length == 2">{{i.children.length}}<unit>màu</unit></small>
      </td>

      <td class="nowrap">

        <div *ngIf="i.Initial.LengthCount > 0"><number class="bold" [good]="'none'" [sign]="false" [value]="i.Initial.LengthQuantity" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.Initial.WeightCount > 0"><number class="bold" [good]="'none'" [sign]="false" [value]="i.Initial.WeightQuantity" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="total('Count', i.Initial) < 1">0</div>
        <small *ngIf="total('Count', i.Initial) > 0">
          <number class="bold" [good]="'none'" [sign]="false" [value]="total('Count', i.Initial)"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>

      </td>

      <td class="nowrap">

        <div *ngIf="i.Imports.LengthCount > 0"><number class="bold" [sign]="false" [good]="'negative'" [value]="i.Imports.LengthQuantity - i.ProviderLosses.LengthQuantity" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.Imports.WeightCount > 0"><number class="bold" [sign]="false" [good]="'negative'" [value]="i.Imports.WeightQuantity - i.ProviderLosses.WeightQuantity" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="total('Count', i.Imports) < 1">0</div>

        <small *ngIf="total('Count', i.Imports) > 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="total('Count', i.Imports)"></number>
          <ng-container *ngIf="total('Count', i.ProviderLosses) > 0">
            <b> - </b>
            <number [sign]="false" [good]="'none'" [value]="total('Count', i.ProviderLosses)"></number>
          </ng-container>
          <unit>{{'cây' | lang}}</unit>
        </small>

      </td>

      <td class="nowrap">

        <div *ngIf="i.Returns.LengthCount > 0"><number class="bold" [sign]="false" [good]="'negative'" [value]="i.Returns.LengthQuantity" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.Returns.WeightCount > 0"><number class="bold" [sign]="false" [good]="'negative'" [value]="i.Returns.WeightQuantity" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="total('Count', i.Returns) < 1">0</div>

        <small *ngIf="total('Count', i.Returns) > 0" class="pointer" (click)="openStatistics(i, 'returns')">
          <number class="bold" [sign]="false" [good]="'none'" [value]="total('Count', i.Returns)"></number>
          <unit>{{'cây' | lang}}</unit> <i class="fa fa-info-circle hlf-margin-left text-primary"></i>
        </small>

      </td>

      <td class="nowrap">
        <div *ngIf="i.Exports.LengthDiscount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.Exports.LengthDiscount" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.Exports.WeightDiscount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.Exports.WeightDiscount" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="total('Discount', i.Exports) == 0">0</div>

        <small *ngIf="total('Discount', i.Imports) > 0">
          <number [sign]="false" [value]="total('Discount', i.Imports.Discount) - total('Discount', i.Exports)" [decimal]="1"></number>
          <b> + </b>
          <number class="bold" [sign]="false" [good]="'none'" [value]="total('Discount', i.Imports)" [decimal]="1"></number>
          <m></m>
        </small>

      </td>

      <td class="nowrap">
        <div *ngIf="i.CompanyLosses.LengthCount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.CompanyLosses.LengthQuantity" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.CompanyLosses.WeightCount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.CompanyLosses.WeightQuantity" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="total('Count', i.CompanyLosses) < 1">0</div>

        <small *ngIf="total('Count', i.CompanyLosses) > 0">
          <number class="bold" [good]="'negative'" [sign]="false" [value]="total('Count', i.CompanyLosses)"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>

      <td class="nowrap">
        <div *ngIf="i.Exports.LengthCount > 0"><number class="bold" [sign]="false" [value]="i.Exports.LengthQuantity" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.Exports.WeightCount > 0"><number class="bold" [sign]="false" [value]="i.Exports.WeightQuantity" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="total('Count', i.Exports) < 1">0</div>

        <small *ngIf="total('Count', i.Exports)" class="pointer" (click)="openStatistics(i, 'exports')">
          <number class="bold" [sign]="false" [good]="'none'" [value]="total('Count', i.Exports)"></number>
          <unit>{{'cây' | lang}}</unit> <i class="fa fa-info-circle text-primary hlf-margin-left"></i>
        </small>
      </td>

      <td class="nowrap">
        <div *ngIf="i.left('length-count') > 0"><number class="bold" [sign]="false" [value]="i.left('length-quantity')" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.left('weight-count') > 0"><number class="bold" [sign]="false" [value]="i.left('weight-quantity')" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="i.left('count') < 1">0</div>

        <small *ngIf="i.left('count') > 0">
          <number class="bold" [good]="'positive'" [value]="i.left('count')"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>
    </tr>
    <tr *ngIf="goods.pages.length > 1">
      <td [colSpan]="9" class="text-center" style="z-index: unset; display: table-cell !important"><pagination [target]="goods"></pagination></td>
    </tr>
    <tr class="footer" *ngIf="goods.matches.length > 1">
      <td></td>
      <td class="bold">{{'TỔNG' | lang}} ({{goods.matches.length}})</td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Initial', 'Quantity')" [decimal]="1"></number>
        <m *ngIf="sum('Initial','LengthCount') > 0 && sum('Initial', 'WeightCount') < 1"></m>
        <kg *ngIf="sum('Initial','LengthCount') < 1 && sum('Initial', 'WeightCount') > 0"></kg>
        <unit *ngIf="sum('Initial','LengthCount') > 0 && sum('Initial', 'WeightCount') > 0">{{'đv' | lang}}</unit>
        <br />
        <small *ngIf="sum('Initial', 'Count') > 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Initial', 'Count')" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Imports') - sum('ProviderLosses')" [decimal]="1"></number>
        <m *ngIf="sum('Imports','LengthCount') > 0 && sum('Imports', 'WeightCount') < 1"></m>
        <kg *ngIf="sum('Imports','LengthCount') < 1 && sum('Imports', 'WeightCount') > 0"></kg>
        <unit *ngIf="sum('Imports','LengthCount') > 0 && sum('Imports', 'WeightCount') > 0">{{'đv' | lang}}</unit>
        <br />
        <small *ngIf="sum('Imports', 'Count') + sum('ProviderLosses', 'Count') > 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Imports', 'Count') - sum('ProviderLosses', 'Count')" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Returns')" [decimal]="1"></number>
        <m *ngIf="sum('Returns','LengthCount') > 0 && sum('Returns', 'WeightCount') < 1"></m>
        <kg *ngIf="sum('Returns','LengthCount') < 1 && sum('Returns', 'WeightCount') > 0"></kg>
        <unit *ngIf="sum('Returns','LengthCount') > 0 && sum('Returns', 'WeightCount') > 0">{{'đv' | lang}}</unit>
        <br />
        <small *ngIf="sum('Returns', 'Count') > 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Returns', 'Count')" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Exports', 'Discount')" [decimal]="1"></number>
        <m *ngIf="sum('Exports','LengthDiscount') > 0 && sum('Exports', 'WeightDiscount') == 0"></m>
        <kg *ngIf="sum('Exports','LengthDiscount') == 0 && sum('Exports', 'WeightDiscount') > 0"></kg>
        <unit *ngIf="sum('Exports','LengthDiscount') > 0 && sum('Exports', 'WeightDiscount') > 0">{{'đv' | lang}}</unit>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('CompanyLosses')" [decimal]="1"></number>
        <m *ngIf="sum('CompanyLosses','LengthCount') > 0 && sum('CompanyLosses', 'WeightCount') < 1"></m>
        <kg *ngIf="sum('CompanyLosses','LengthCount') < 1 && sum('CompanyLosses', 'WeightCount') > 0"></kg>
        <unit *ngIf="sum('CompanyLosses','LengthCount') > 0 && sum('CompanyLosses', 'WeightCount') > 0">{{'đv' | lang}}</unit>
        <br />
        <small *ngIf="sum('CompanyLosses', 'Count') > 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="sum('CompanyLosses', 'Count')" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Exports')" [decimal]="1"></number>
        <m *ngIf="sum('Exports','LengthCount') > 0 && sum('Exports', 'WeightCount') < 1"></m>
        <kg *ngIf="sum('Exports','LengthCount') < 1 && sum('Exports', 'WeightCount') > 0"></kg>
        <unit *ngIf="sum('Exports','LengthCount') > 0 && sum('Exports', 'WeightCount') > 0">{{'đv' | lang}}</unit>
        <br />
        <small *ngIf="sum('Exports', 'Count') > 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Exports', 'Count')" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('left')" [decimal]="1"></number>
        <m *ngIf="sum('left','length-count') > 0 && sum('left', 'weight-count') < 1"></m>
        <kg *ngIf="sum('left','length-count') < 1 && sum('left', 'weight-count') > 0"></kg>
        <unit *ngIf="sum('left','length-count') > 0 && sum('left', 'weight-count') > 0">{{'đv' | lang}}</unit>
        <br />
        <small *ngIf="sum('left', 'count') > 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="sum('left', 'count')" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>
    </tr>
  </table>
</panel>

<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
